export const selectedComparison = (state, payload) => {
    return {
      ...state,
      heatmapConfiguration: {
        ...state.heatmapConfiguration,
        comparisonColumn: payload,
      },
    };
  };
  